function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var StackUtils = function StackUtils() {};

_defineProperty(StackUtils, "selStack", function (i) {
  return function (d) {
    return d.value[i];
  };
});

_defineProperty(StackUtils, "getUnique", function (dimension, uniqueKey) {
  var types = dimension.top(Infinity).map(function (d) {
    return '' + d[uniqueKey];
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }).sort();
  return types;
});

export default StackUtils;